import React from "react";
import { Link, useLocation } from "react-router-dom";
import "./BreadcrumbNav.css";

/**
 * BreadcrumbNav Component
 *
 * Segment behaviour:
 * - No path (folder-only group like "Admin", "Question Paper") → always plain text
 * - Has path + current URL matches → plain text (you are here)
 * - Has path + current URL differs → clickable link (back-navigation)
 */
const BreadcrumbNav = ({
  segments = [],
  onNavigate,
  separator = " > ",
  className = "",
}) => {
  const location = useLocation();

  if (!segments || segments.length === 0) {
    return <span className="breadcrumb-text">Home</span>;
  }

  return (
    <nav className={`breadcrumb-nav ${className}`} aria-label="Breadcrumb">
      <ol className="breadcrumb-list">
        {segments.map((segment, index) => {
          // We are currently on this page
          const isCurrentPage =
            segment.path && segment.path === location.pathname;

          // Show as link only when: has a path AND not the current page
          const showAsLink =
            segment.isClickable && segment.path && !isCurrentPage;

          return (
            <li key={index} className="breadcrumb-item">
              {showAsLink ? (
                <Link
                  to={segment.path}
                  className="breadcrumb-link"
                  onClick={() => onNavigate && onNavigate(segment)}
                  title={`Go to ${segment.name}`}
                >
                  {segment.name}
                </Link>
              ) : (
                <span
                  className={`breadcrumb-text ${isCurrentPage ? "breadcrumb-current" : ""}`}
                  aria-current={isCurrentPage ? "page" : undefined}
                >
                  {segment.name}
                </span>
              )}

              {!segment.isLast && (
                <span className="breadcrumb-separator" aria-hidden="true">
                  {separator}
                </span>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
};

export const BreadcrumbText = ({ pagePath }) => (
  <span className="breadcrumb-text-simple">{pagePath || "Home"}</span>
);

export default BreadcrumbNav;